import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceARPayableClaimActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/PayableClaim/PayableClaimBrowser")
	}

	render() {
		return (
			<Activity 
				name="FinanceARPayableClaim"
				RenderedComponent={this.RenderedComponent}
				context="FinanceARPayableClaim"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceARPayableClaimActivity)
